module.exports = __webpack_public_path__ + "img/face-angry-horns.8eae4bd4.svg";